

























































import { Vue, Component, Prop } from "vue-property-decorator";
@Component
export default class OrderItemsSummary extends Vue {
  // Props
  @Prop({ required: false, default: () => [] })
  public items!: [];

  @Prop({ default: "span" })
  public readonly tag!: string;
  // Data
  public limit = 6;
  // Getters
  public get itemsLimited() {
    return this.$_.take(this.items, this.limit);
  }
  public get itemsRemaining() {
    return this.$_.slice(this.items, this.limit);
  }
}
